'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@repo/ui/lib/utils';
import { Flags1x1 } from '@repo/ui/flags';
const isFlagCode = (code: string): code is keyof typeof Flags1x1 => Object.hasOwn(Flags1x1, code);
export const CompanyCountryFlag = t0 => {
  const $ = _c(6);
  const {
    className,
    code,
    name
  } = t0;
  const Flag = code && isFlagCode(code) ? Flags1x1[code] : null;
  if (!Flag) {
    return null;
  }
  const t1 = name ?? code ?? undefined;
  let t2;
  if ($[0] !== className) {
    t2 = cn("inline-block size-4 rounded-full border border-border fill-black", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== Flag || $[3] !== t1 || $[4] !== t2) {
    t3 = <Flag aria-label={t1} className={t2} role="img" data-sentry-element="Flag" data-sentry-component="CompanyCountryFlag" data-sentry-source-file="company-country-flag.tsx" />;
    $[2] = Flag;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};